import React, {useContext, useRef, useEffect, useState} from "react";

import { ProductCustomizerVariantContext } from "@contexts/ProductCustomizerVariant.jsx"
import { Engine } from "json-rules-engine"
import AjaxPage from "@components/general/AjaxPage.jsx"
import ProductCustomizerNoteFooter from "./ProductCustomizerNoteFooter.jsx"

export default ({children}) => {

  const [dismissed, setDismissed] = useState(false);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const rulesEngine = useRef(new Engine());
  const { variant, product} = useContext(ProductCustomizerVariantContext);

  useEffect(() => {
    if(!product) return;

    const notes = collateNoteMetafields(product?.cartNotes);

    notes.forEach((note) => {
      try{
        rulesEngine.current.addRule({
          conditions: {
            ...note.rules
          },
          event: {
            type: 'popup',
            params: {
              page: note.page,
              priority: note.priority
            }
          }
        });
      }catch(e){
        console.error(`Issue with cart note: ${note.page}`);
        console.error(e);
      }
    });

    if(!variant) return;

    setLoading(true);
    setDismissed(false);

    const vehicle = VehicleData.getSelectedVehicle();

    let facts = {
        ...vehicle,
        option1: variant?.options[0]?.value,
        option2: variant?.options[1]?.value,
        option3: variant?.options[2]?.value,
        sku: variant?.sku,
        qty: 1, // default to 1 in customizer
        available: variant?.available,
      }
    
    if(location.search.includes("debug")){
      console.log("======== DEBUGGING CART POPUP RULES ========");
      console.log("Facts:", facts);
      console.log("Popups:", notes);
    }
  
    rulesEngine.current
      .run(facts)
      .then(({ events }) => {
        events = events.sort((a, b) => a.params.priority - b.params.priority);
        setEvents(events);
        setLoading(false);
      });

  }, [product, variant, rulesEngine]);

  const noteEvent = events.find(({type}) => type == "popup");

  return <>
            { loading ?
                <pill-loader class="pill-loader" aria-busy={loading}></pill-loader>
              :
                ( noteEvent && !dismissed ?
                      <>
                        <AjaxPage handle={noteEvent.params?.page} />
                        <ProductCustomizerNoteFooter onClick={() => setDismissed(true)} />
                      </>
                    :
                      children
                )
            }
         </>;
}


const collateNoteMetafields = (notesFields) => {

  notesFields = notesFields.filter((field) => field);
  if(!notesFields) return [];

  let pages, rules, priorities;
  try{
    pages = JSON.parse(notesFields.find(({key}) => key == "page")?.value);
    rules = JSON.parse(notesFields.find(({key}) => key == "rules")?.value);
    priorities = JSON.parse(notesFields.find(({key}) => key == "priority")?.value);
  }catch(e){
    console.log(e)
    return [];
  }

  if(!pages) return [];

  const notes = pages.map((page, index) => {
    return {
      page,
      rules: rules ? rules[index] : {},
      priority: priorities ? priorities[index] : 0
    }
  });

  return notes.sort(function(a, b) {
      return parseFloat(a.priority) - parseFloat(b.priority);
  });
}
